import React from 'react';
import {
   Dialog,
   DialogContent,
   DialogDescription,
   DialogHeader,
   DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Settings, FilePlus } from "lucide-react";

const COVActionDialog = ({ isOpen, onClose, onEditPreset, onCreateApplication }) => {
   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
               <DialogTitle>COV Application</DialogTitle>
               <DialogDescription>
                  Choose whether to edit the preset or create a new application
               </DialogDescription>
            </DialogHeader>
            <div className="grid grid-cols-2 gap-4 pt-4">
               <Button
                  variant="outline"
                  onClick={onEditPreset}
                  className="flex items-center gap-2"
               >
                  <Settings className="h-4 w-4" />
                  Edit Preset
               </Button>
               <Button
                  onClick={onCreateApplication}
                  className="flex items-center gap-2"
               >
                  <FilePlus className="h-4 w-4" />
                  Create Application
               </Button>
            </div>
         </DialogContent>
      </Dialog>
   );
};

export default COVActionDialog; 